<template>
  <div class="main" >
    <el-container >
      <el-aside class="aside"  :width="asideWidth" 
	  @mouseenter.native="collapseOpen" @mouseleave.native="collapseClose">
	  
	  <!-- 点击控制显示与隐藏 begin -->
	   <button @click="collapseStatus"><i class="el-icon-d-arrow-right"></i> </button>
	   <!-- 点击控制显示与隐藏 end -->
	   
        <el-header class="aside-header" style="height: 150px" >	  
          <div class="text-center mt40 disFlex pl20">
            <img src="@/assets/imgs/logo.png" class="radius-wp50" width="60" height="60" alt="">
            <div class="c-fff ml10 text-left">
              <p class="font16 mt10">管理</p>
              <p class="font14 mt10">talk</p>
            </div>
          </div>
        </el-header>

        <div class="aside-menu"  >
          <el-menu class="menu-bg"  :collapse="isCollapse"
                   text-color="#fff"
                   router
                   background-color="#2F4050"
                   active-text-color="#409EFF"
                   :default-active="$route.path">
            <template v-for="(item,key) in menuList">
              <el-submenu :index="item.url" :key="key" v-if="item.children">
                <template slot="title">
                  <i class="iconfont font18" :class="item.icon"></i>
                  <span class="pl15">{{item.name}}</span>
                </template>
                <el-menu-item v-for="item2 in item.children" :key="item2.url" :index="item2.url">
                  {{item2.name}}
                </el-menu-item>
              </el-submenu>
              <el-menu-item :index="item.url" v-else :key="key">
                <template slot="title">
                  <i class="iconfont pl20 font18" :class="item.icon"></i>
                  <span class="pl15">{{item.name}}</span>
                </template>
              </el-menu-item>
            </template>
          </el-menu>
        </div>
      
	  </el-aside>

      <el-container >
        <el-header class="header-bg" style="height: 50px;" >
          <el-dropdown class="cursor-pointer fr" size="medium" style="height: 50px;line-height: 50px;">
            <div class="c-000 dlblock">
              {{nickName}}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="outBtn">
                退出登录
              </el-dropdown-item>
              <!--              <el-dropdown-item class="rel">-->
              <!--                修改头像-->
              <!--                <input class="file" name='file' accept="image/*" type="file" @change="imgChange">-->
              <!--              </el-dropdown-item>-->
              <el-dropdown-item @click.native="pwdBtn">
                修改密码
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-header>

        <el-main>
          <transition name="el-fade-in-linear" mode="out-in">
            <router-view></router-view>
          </transition>
        </el-main>
      </el-container>
    </el-container>

    <!-- 修改密码 -->
    <el-dialog title="修改密码" ref="formPwd" width="400px" :visible.sync="pwdData.modal">
      <el-form ref="form" :model="pwdData" :rules="rules" label-width="80px" label-position="left">
        <el-form-item prop="oldPwd" label="原密码">
          <el-input
              class="form-input"
              type="password"
              placeholder="请输入原密码"
              v-model.trim="pwdData.oldPwd">
          </el-input>
        </el-form-item>
        <el-form-item prop="newPwd" label="新密码">
          <el-input
              class="form-input"
              placeholder="请输入新密码"
              type="password"
              v-model.trim="pwdData.newPwd">
          </el-input>
        </el-form-item>
        <el-form-item prop="againPwd" class="text-center" label="确认密码">
          <el-input
              class="form-input"
              placeholder="请再次输入新密码"
              type="password"
              v-model.trim="pwdData.againPwd">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="text-center">
        <el-button @click="pwdData.modal = false">取 消</el-button>
        <el-button type="primary" @click="pwdSave">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  // import {uploadImg} from '@/api/upload'
  import {getUserData, setUserPWD,
  //菜单权限
  ydGetMenuPermissions} from '@/api'
  import {mapMutations} from 'vuex'
  import {generateRoutes} from '@/permission.js'

  const menuList = [
    {
      name: '首页',
      icon: 'el-icon-s-data',
      url: '/home',
      children: null
    },
	{
	  name: '综合商户',
	  url: '/snh',
	  icon: 'el-icon-s-data',
	  children: [
	    {
	      name: '商户管理',
	      icon: 'el-icon-s-data',
	      url: '/snh/merchantManagement',
	      children: null,
	    },
		{
		  name: '订单',
		  icon: 'el-icon-s-data',
		  url: '/snh/order',
		  children: null,
		},
		{
		  name: '活动',
		  icon: 'el-icon-s-data',
		  url: '/snh/fullReductionActivities',
		  children: null,
		},
		{
		  name: '交易明细',
		  icon: 'el-icon-s-data',
		  url: '/snh/transactionDetails',
		  children: null,
		},
		{
		  name: '内转出金对账单',
		  icon: 'el-icon-s-data',
		  url: '/snh/transactionInwardTurnWithStnt',
		  children: null,
		},
		{
		  name: '平台商户对账单',
		  icon: 'el-icon-s-data',
		  url: '/snh/transactionPlatformMerchantStatement',
		  children: null,
		},
		{
		  name: '微信支付宝对账单',
		  icon: 'el-icon-s-data',
		  url: '/snh/transactionWxAli',
		  children: null,
		},
		{
		  name: '出金记录',
		  icon: 'el-icon-s-data',
		  url: '/snh/outOfGoldDetails',
		  children: null,
		},
		{
		  name: '入金记录',
		  icon: 'el-icon-s-data',
		  url: '/snh/inOfGoldDetails',
		  children: null,
		},
		{
		  name: '交易对账单',
		  icon: 'el-icon-s-data',
		  url: '/snh/transactionStatement',
		  children: null,
		},
		{
		  name: '营销补贴',
		  icon: 'el-icon-s-data',
		  url: '/snh/marketingSubsidies',
		  children: null,
		},
		{
		  name: '商户汇总',
		  icon: 'el-icon-s-data',
		  url: '/snh/merchantOrderSummary',
		  children: null,
		},
		{
		  name: '云喇叭',
		  icon: 'el-icon-s-data',
		  url: '/snh/merchantCloudTrumpet',
		  children: null,
		},
		{
		  name: '白名单',
		  icon: 'el-icon-s-data',
		  url: '/snh/whiteList',
		  children: null,
		}
	  ],
	},
    {
      name: '用户管理',
      url: '/user',
      icon: 'el-icon-s-data',
      children: [
        {
          name: 'talk用户',
          icon: 'el-icon-s-data',
          url: '/user/list',
          children: null,
        },
		{
		  name: '银达用户',
		  icon: 'el-icon-s-data',
		  url: '/ydUser/list',
		  children: null,
		},
        {
          name: '省农行用户',
          icon: 'el-icon-s-data',
          url: '/user/userList',
          children: null,
        },
        {
          name: '省农行食堂短信群发',
          icon: 'el-icon-s-data',
          url: '/user/canteenSms',
          children: null,
        },
        {
          name: '设备人脸识别日志',
          icon: 'el-icon-s-data',
          url: '/user/equipment',
          children: null,
        },{
          name: '交易流水',
          icon: 'el-icon-s-data',
          url: '/user/transactionFlow',
          children: null,
        },{
          name: '用户余额',
          icon: 'el-icon-s-data',
          url: '/user/userBalance',
          children: null,
        },{
          name: '刷脸记录与交易流水',
          icon: 'el-icon-s-data',
          url: '/user/faceBrushingAndTrading',
          children: null,
        }
      ],
    },
	{
	  name: '单词管理',
	  url: '/enWord',
	  icon: 'el-icon-s-data',
	  children: [
	    {
	      name: '单词列表',
	      icon: 'el-icon-s-data',
	      url: '/word/wordList',
	      children: null,
	    }, 
		{
	      name: '单词包',
	      icon: 'el-icon-s-data',
	      url: '/word/wordPackage',
	      children: null,
	    }
	  ],
	},
	{
	  name: '海康视威',
	  url: '/hk',
	  icon: 'el-icon-s-data',
	  children: [
	    {
	      name: '人脸识别记录',
	      icon: 'el-icon-s-data',
	      url: '/hk/FaceRecognitionRecord',
	      children: null,
	    }
	  ],
	},
	{
	  name: '虹软',
	  url: '/arcsoft',
	  icon: 'el-icon-s-data',
	  children: [
	    {
	      name: '人脸库',
	      icon: 'el-icon-s-data',
	      url: '/arcsoft/faceDatabase',
	      children: null,
	    },
		{
		  name: '组列表查询',
		  icon: 'el-icon-s-data',
		  url: '/arcsoft/groupListQuery',
		  children: null,
		}
	  ],
	},
	// {
	//   name: '客如云',
	//   url: '/kry',
	//   icon: 'el-icon-s-data',
	//   children: [
	//     {
	//       name: '订单列表',
	//       icon: 'el-icon-s-data',
	//       url: '/kry/order',
	//       children: null,
	//     }
	//   ],
	// },
	{
	  name: '二维码',
	  url: '/QRCode',
	  icon: 'el-icon-s-data',
	  children: [
	    {
	      name: '二维码列表',
	      icon: 'el-icon-s-data',
	      url: '/QRCode/list',
	      children: null,
	    }
	  ],
	},
    {
      name: '资讯管理',
      url: '/information',
      icon: 'el-icon-s-data',
      children: [
        {
          name: '资讯发布',
          icon: 'el-icon-s-data',
          url: '/information/edit',
          children: null,
        },
        {
          name: '我的资讯',
          icon: 'el-icon-s-data',
          url: '/information/platform',
          children: null,
        },
        // {
        //   name: '资讯审核',
        //   icon: 'el-icon-s-data',
        //   url: '/information/auth',
        //   children: null,
        // },
        // {
        //   name: '资讯设置',
        //   icon: 'el-icon-s-data',
        //   url: '/information/settings',
        //   children: null,
        // },
      ],
    },
    // {
    //   name: '视频管理',
    //   url: '/video',
    //   icon: 'el-icon-s-data',
    //   children: [
    //     {
    //       name: '视频发布',
    //       icon: 'el-icon-s-data',
    //       url: '/video/edit',
    //       children: null,
    //     },
    //     {
    //       name: '我的视频',
    //       icon: 'el-icon-s-data',
    //       url: '/video/platform',
    //       children: null,
    //     },
    //     {
    //       name: '视频审核',
    //       icon: 'el-icon-s-data',
    //       url: '/video/auth',
    //       children: null,
    //     },
    //   ]
    // },
    // {
    //   name: '广告管理',
    //   url: '/ad',
    //   icon: 'el-icon-s-data',
    //   children: [
    //     {
    //       name: '发布广告',
    //       icon: 'el-icon-s-data',
    //       url: '/ad/edit',
    //       children: null,
    //     },
    //     {
    //       name: '我的广告',
    //       icon: 'el-icon-s-data',
    //       url: '/ad/platform',
    //       children: null,
    //     },
    //     {
    //       name: '广告审核',
    //       icon: 'el-icon-s-data',
    //       url: '/ad/auth',
    //       children: null,
    //     },
    //     {
    //       name: '广告设置',
    //       icon: 'el-icon-s-data',
    //       url: '/ad/settings',
    //       children: null,
    //     },
    //   ]
    // },
    // {
    //   name: '活动管理',
    //   url: '/activity',
    //   icon: 'el-icon-s-data',
    //   children: [
    //     {
    //       name: '活动列表',
    //       icon: 'el-icon-s-data',
    //       url: '/activity/list',
    //       children: null,
    //     },
    //   ]
    // },
    // {
    //   name: '寻人管理',
    //   url: '/lost',
    //   icon: 'el-icon-s-data',
    //   children: [
    //     {
    //       name: '寻人审核',
    //       icon: 'el-icon-s-data',
    //       url: '/lost/auth',
    //       children: null,
    //     },
    //     {
    //       name: '寻人分类',
    //       icon: 'el-icon-s-data',
    //       url: '/lost/classify',
    //       children: null,
    //     },
    //   ]
    // },
    // {
    //   name: '小视频管理',
    //   url: '/small',
    //   icon: 'el-icon-s-data',
    //   children: [
    //     {
    //       name: '视频审核',
    //       icon: 'el-icon-s-data',
    //       url: '/small/auth',
    //       children: null,
    //     },
    //   ]
    // },
    // {
    //   name: '代理商管理',
    //   url: '/agent',
    //   icon: 'el-icon-s-data',
    //   children: [
    //     {
    //       name: '代理商列表',
    //       icon: 'el-icon-s-data',
    //       url: '/agent/list',
    //       children: null,
    //     },
    //   ]
    // },
    // {
    //   name: '钱包管理',
    //   url: '/wallet',
    //   icon: 'el-icon-s-data',
    //   children: [
    //     {
    //       name: '钱包列表',
    //       icon: 'el-icon-s-data',
    //       url: '/wallet/list',
    //       children: null,
    //     },
    //     {
    //       name: '提现审核',
    //       icon: 'el-icon-s-data',
    //       url: '/wallet/auth',
    //       children: null,
    //     },
    //   ]
    // },
    // {
    //   name: '礼物管理',
    //   url: '/gift',
    //   icon: 'el-icon-s-data',
    //   children: [
    //     {
    //       name: '礼物列表',
    //       icon: 'el-icon-s-data',
    //       url: '/gift/list',
    //       children: null,
    //     },
    //   ]
    // },
    // {
    //   name: '举报管理',
    //   url: '/report',
    //   icon: 'el-icon-s-data',
    //   children: [
    //     {
    //       name: '举报列表',
    //       icon: 'el-icon-s-data',
    //       url: '/report/list',
    //       children: null,
    //     },
    //   ]
    // },
    // {
    //   name: '实物抵扣',
    //   url: '/deduction',
    //   icon: 'el-icon-s-data',
    //   children: [
    //     {
    //       name: '实物抵扣列表',
    //       icon: 'el-icon-s-data',
    //       url: '/deduction/list',
    //       children: null,
    //     },
    //   ]
    // },
    // {
    //   name: '红包地图',
    //   url: '/map',
    //   icon: 'el-icon-s-data',
    //   children: [
    //     {
    //       name: '红包地图',
    //       icon: 'el-icon-s-data',
    //       url: '/map/red',
    //       children: null,
    //     },
    //     {
    //       name: '我的红包',
    //       icon: 'el-icon-s-data',
    //       url: '/map/mine',
    //       children: null,
    //     },
    //   ]
    // },
    // {
    //   name: '敏感词屏蔽',
    //   url: '/sensitive',
    //   icon: 'el-icon-s-data',
    //   children: [
    //     {
    //       name: '敏感词',
    //       icon: 'el-icon-s-data',
    //       url: '/sensitive/word',
    //       children: null,
    //     },
    //   ]
    // },
    // {
    //   name: '图库管理',
    //   url: '/gallery',
    //   icon: 'el-icon-s-data',
    //   children: null
    // },
    {
      name: '角色权限',
      url: '/role',
      icon: 'el-icon-s-data',
      children: [
        // {
        //   name: '用户管理',
        //   icon: 'el-icon-s-data',
        //   url: '/role/user',
        //   children: null,
        // },
        {
          name: '角色管理',
          icon: 'el-icon-s-data',
          url: '/role/auth',
          children: null,
        },
      ]
    },
	{
	  name: '菜单管理',
	  url: '/menu',
	  icon: 'el-icon-s-data',
	  children: [
	    {
	      name: '菜单列表',
	      icon: 'el-icon-s-data',
	      url: '/menu/list',
	      children: null,
	    },
	    {
	      name: '菜单树',
	      icon: 'el-icon-s-data',
	      url: '/menu/menuTree',
	      children: null,
	    }
	  ]
	},
    {
      name: '平台设置',
      url: '/settings',
      icon: 'el-icon-s-data',
      children: [
        {
          name: '隐私协议',
          icon: 'el-icon-s-data',
          url: '/settings/privacy',
          children: null,
        },
        {
          name: '用户管理协议',
          icon: 'el-icon-s-data',
          url: '/settings/user',
          children: null,
        },
        {
          name: '关于我们',
          icon: 'el-icon-s-data',
          url: '/settings/about',
          children: null,
        },
        {
          name: '免责申明',
          icon: 'el-icon-s-data',
          url: '/settings/disclaimer',
          children: null,
        },
      ]
    },
  ]

  export default {
    data () {
      const validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'))
        } else if (value.length < 6) {
          callback(new Error('密码不少于6位'))
        } else {
          callback()
        }
      }
      const validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'))
        } else if (value.length < 6) {
          callback(new Error('密码不少于6位'))
        } else {
          callback()
        }
      }
      const validatePass3 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'))
        } else if (value !== this.pwdData.newPwd) {
          callback(new Error('两次输入密码不一致,请重新输入!'))
        } else {
          callback()
        }
      }
      return {
		  //控制隐藏和显示
		  collapseBtnClick:false,
		  //宽度
		  asideWidth:'200px',
        rules: {
          oldPwd: [{validator: validatePass, trigger: 'blur'}],
          newPwd: [{validator: validatePass2, trigger: 'blur'}],
          againPwd: [{validator: validatePass3, trigger: 'blur'}]
        },
        // 修改密码数据
        pwdData: {
          modal: false,
          oldPwd: '',
          newPwd: '',
          againPwd: ''
        },
        menuList: menuList,
		//隐藏 显示
		isCollapse:false
      }
    },
    computed: {
      nickName () {
        return this.$store.state.nickName;
      },
    },
    created () {
		console.info("菜单列表",JSON.stringify(menuList))
		
		//重置上面配置，从数据库加载
		this.menuList = null
		
		//刷新回到初始页面的地方
      generateRoutes(menuList).then(() => {
		  let url = menuList[1].url
		  console.info("刷新回到初始页面的地方: " + url)
		  //首页
		  //url = '/home'
		  //商户管理
		  //url = '/snh/merchantManagement'
		  //银达用户
		  //url = '/snh/fullReductionActivities'
		  //临时
		  url = '/snh/fullReductionActivities'
		  console.info("url刷新回到初始页面的地方: " + url)
        this.$router.push(url)
      })
      // 通过token查询是哪个角色
      if (localStorage.token) {
		
		//菜单权限
		this.getMenuPermissions()
		  
        // 未登录获取菜单
        //  router.addRoutes(filterAsyncRoutes(asyncRoutes, roles))
        //  this.getUserDataFn()
        // this.menuList = menuList
        // sessionStorage.setItem('menuList', JSON.stringify(menuList))

        // 已登录直接取session
        // const menuListSession = JSON.parse(sessionStorage.getItem('menuList'))
        // if (Array.isArray(menuListSession) && menuListSession.length) {
        //   this.menuList = menuListSession
        // } else {
        //   // 重新获取
        //   this.menuList = menuListSession
        //   sessionStorage.setItem('menuList', JSON.stringify(menuList))
        // }
        // generateRoutes(menuListSession).then(() => {
        //   this.$router.push(menuListSession[0].url)
        // })

        // 要删除
        // generateRoutes(menuList).then(() => {
        //   this.$router.push(menuList[0].url)
        // })
      } else {
        // this.$message.warning('请登录')
        // this.$router.push('/')
      }
    },
    methods: {
      ...mapMutations([
        'changeNickName',
        'changeUserType',
      ]),
	    collapseStatus() {
	        this.collapseBtnClick = this.isCollapse;
	        this.isCollapse = !this.isCollapse;
	    },
	    collapseOpen() {
	        if (this.collapseBtnClick) return;
	        this.isCollapse = false;
			this.asideWidth = '200px'
	    },
	    collapseClose() {
	        if (this.collapseBtnClick) return;
	        this.isCollapse = true;
			this.asideWidth = '20px'
	    },
      /*imgChange (e) {
        const file = e.target.files[0]
        const param = new FormData()
        param.append('file', file)
        uploadImg(param).then(res => {
          if (res.code == 200) {
            setMessageHeadImg(res.data).then(res2 => {
              this.$message.success('操作成功')
              this.$store.commit('changeHeadImg', res.data)
            })
          } else {
            this.$message.warning(res.msg)
          }
        })
      },*/
      // 提交密码
      pwdSave () {
        this.$refs['form'].validate(valid => {
          if (valid) {
            setUserPWD({
              oldPwd: this.pwdData.oldPwd,
              newPwd: this.pwdData.newPwd,
              confirmPwd: this.pwdData.againPwd,
            }).then(res => {
              this.$message.success(res.data)
              this.pwdData.modal = false
            })
          } else {
            return false
          }
        })
      },
      // 修改密码
      pwdBtn () {
        this.pwdData = {
          modal: true,
          oldPwd: '',
          newPwd: '',
          againPwd: ''
        }
      },
      getUserDataFn () {
        getUserData().then(res => {
          localStorage.token = res.data.token
          localStorage.userType = res.data.userTypeEnum.name
          this.$store.commit('changeNickName', res.data.loginName)

          if (res.data.userTypeEnum.name == 'ADMIN_PARK') {
            this.menuList = menuList
            if (this.$route.name == 'Main') {
              this.$router.push(menuList[0].children[0].url)
            }
          } else {
            this.menuList = menuList2
            if (this.$route.name == 'Main') {
              this.$router.push(menuList2[0].url)
            }
          }
        })
      },
      outBtn () {
        localStorage.clear()
        this.$router.push('/')
      },
	  //菜单权限
	  getMenuPermissions(){
		  ydGetMenuPermissions().then(res => {
		    if (res.code == 200) {
		      console.info("菜单权限===",res.data)
			  this.menuList = res.data[0].children[1].children
			  console.info("菜单权限1===",res.data[0].children[1].children)
		    }
		  })
	  }
    }
  }
</script>

<style scoped>
  .header-bg {
    background-color: #ffffff;
  }

  .title {
    height: 50px;
    background-color: #2F4050;
    color: #fff;
    text-align: center;
    line-height: 50px;
  }

  .main {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .el-main {
    background-color: #EEF0F5;
    padding: 0;
  }

  .el-container {
    height: 100%;
  }

  .aside {
    position: relative;
    width: 200px;
    height: 100%;
    background-color: #2F4050;
  }

  .aside-header {
    position: absolute;
    top: 0;
    width: 100%;
    padding: 0;
  }

  .aside-menu {
    position: absolute;
    width: 100%;
    top: 150px;
    bottom: 0;
    overflow: auto;
  }

  .aside-menu::-webkit-scrollbar {
    width: 0;
    height: 0;
  }

  .menu-bg > .el-menu-item, .el-submenu {
    padding: 0 !important;
    width: 200px;
    text-align: left;
  }

  .file {
    position: absolute;
    opacity: 0;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    cursor: pointer;
    font-size: 0;
  }

  .el-menu-item i {
    color: inherit;
  }

  .el-submenu__title i {
    color: inherit;
  }
</style>
